<glxy-page [isLoading]="isWorkOrderLoading$$ | async">
  <glxy-page-toolbar class="sticky">
    <glxy-page-title>
      @if (partnerLogoUrl$ | async; as logoUrl) {
        <img class="partner-logo" [src]="logoUrl" />
      }
    </glxy-page-title>

    <glxy-page-actions>
      <div class="completion-count">
        <div class="completion-count-title">
          {{ 'WORK_ORDERS.FULFILLMENT_FORMS' | translate }}
        </div>
        <div>
          {{ workOrdersCompleted }}
        </div>
      </div>
    </glxy-page-actions>
  </glxy-page-toolbar>
  <div class="spacer"></div>
  <glxy-page-wrapper [maxWidth]="1160">
    @if (workOrders$ | async; as workOrders) {
      @if (showBanner) {
        <glxy-alert type="warning">
          <span class="alert-banner-title">{{ 'WORK_ORDERS.PUBLIC_FORM.ALERT_TITLE' | translate }}</span>
          - {{ 'WORK_ORDERS.PUBLIC_FORM.ALERT_SUBTITLE' | translate }}
        </glxy-alert>
      }
      @for (wo of workOrders; track wo; let i = $index) {
        <div class="work-order-form-container">
          <ng-template #extraHeaderContent>
            @if (wo.fulfillmentOrderId) {
              <work-order-status-badge
                [value]="wo.status"
                class="status-badge"
                [persona]="persona"
                [attr.id]="wo.fulfillmentOrderId"
                [attr.fragment]="wo.fulfillmentOrderId"
              ></work-order-status-badge>
            }
          </ng-template>
          <work-order-form
            [salesOrderId]="wo.salesOrderId"
            [appId]="wo.appId"
            [accountGroupId]="wo.businessId"
            [resellerPartnerId]="wo.resellerPartnerId"
            [fulfillmentOrderId]="wo.fulfillmentOrderId"
            [status]="wo.status"
            [persona]="persona"
            [marketId]="wo?.businessInfo?.marketId"
            [extraHeaderContent]="extraHeaderContent"
            (fulfillmentOrderStatusChanged)="statusChanged($event, wo)"
            [showOfficeUseQuestions]="false"
            (doneLoading)="handleDoneLoading(i)"
          ></work-order-form>
        </div>
      }
      @if ((woFormDoneLoading$ | async) === false) {
        <div class="stencil-shimmer loading-shimmer"></div>
      }
    }
  </glxy-page-wrapper>
</glxy-page>
